<app-user-work-attendance-dashboard-subheader (queryChange)="this.onQueryChange($event)" />

<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container container-fluid">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row mb-3">
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_PRESENT_ON_DAY' | translate"
                      [kpiData]="this.presenceCount()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_ARRIVAL' | translate"
                      [kpiData]="this.medianStart()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_DEPARTURE' | translate"
                      [kpiData]="this.medianEnd()"
                    />
                  </div>
                  <div class="col-3">
                    <app-kpi
                      [title]="'ATTENDANCE_LBL_MEDIAN_AMPLITUDE' | translate"
                      [kpiData]="this.medianAmplitude()"
                    />
                  </div>
                </div>

                @if (this.day(); as day) {
                  <h6 class="card-title mb-1">{{ day | date: 'fullDate' }}</h6>
                }

                <div class="attendance-chart" [style.height.px]="this.chartHeightPx()">
                  <canvas #chartCanvas></canvas>
                </div>

                <app-attendance-chart-legend [showFormerEmployee]="this.hasFormerEmployees()" />

                @if (!this.isWorkingDay()) {
                  <div class="text-muted text-center py-4">
                    {{ 'ATTENDANCE_LBL_NO_WORKING_DAY' | translate }}
                  </div>
                } @else if (!this.hasRows()) {
                  <div class="text-muted text-center py-4">
                    {{ 'ATTENDANCE_LBL_NO_DATA' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
